export default (
  element
) => {
  const { dataset, style } = element
  const { clientX, clientY } = dataset
  
  style.left = `${clientX}px`
  style.top = `${clientY}px`
}
